import { DisplayMode } from '@flywire/internal-components/model';

import { ENDPOINTS } from '../../endpoints';

export type LRSUrlBuilderParams = {
  paymentId: string;
  paymentToken: string;
  requireAllDocuments?: boolean;
  displayMode?: DisplayMode;
};

export const lrsUrlBuilder = (params: LRSUrlBuilderParams): string => {
  const { paymentId, paymentToken, requireAllDocuments, displayMode = 'full-screen' } = params;

  const url = `${ENDPOINTS.lrsForm}?payment_id=${encodeURIComponent(paymentId)}&payment_token=${encodeURIComponent(paymentToken)}&display_mode=${encodeURIComponent(displayMode)}`;

  return requireAllDocuments !== undefined
    ? `${url}&require_all_documents=${encodeURIComponent(requireAllDocuments)}`
    : url;
};
